import axios from '../config/axios'

export const getPrespostActivity = ()=> axios.get('/participant/prepostActivity')
export const getPrepostActivotyById = (activityId) => axios.get(`/participant/prepostActivity/${activityId}`)
export const saveParticipantAnswerPreposActivity =(data, activityId) => axios.put(`/participant/prepostActivity/${activityId}/save`, data)